import { z } from 'zod';

import { translationKey } from '@change-corgi/core/i18n';

import type { PetitionEditPageData, PetitionEditPageState } from 'src/app/pages/petitionEditV2/pageContext';

export const GEO_REACH_VALUES = ['local', 'national', 'global'] as const;
export const scopeSchema = z.enum(GEO_REACH_VALUES, {
	error: (issue) =>
		issue.input === undefined
			? (translationKey('corgi.petition.edit.petition_data.scope.error') as unknown as string)
			: issue.message, // need translation
});

type FormStateGeoReach = PetitionEditPageState['formState']['geoReach'];

// transform petition GET API data to formState structure
export const deserializeScope = ({ petition }: PetitionEditPageData): FormStateGeoReach => ({
	value: petition.geoReach ?? undefined,
	error: null,
	dirty: false,
});
